import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../../Utils/thunkHelpers"
import { getStatisticsAdmin } from "../../../BusinessAccountsPage/redux/businessAccounts.thunks"
import * as services from "../services"
import { REQUESTS_ENROLLMENTS_SLICE_NAME } from "./requestsEnrollments.constants"

export const getRequestsEnrollmentsFilterOptions = createAsyncThunk(
  `${REQUESTS_ENROLLMENTS_SLICE_NAME}/get_requests_enrollments_filter_options`,
  async (_, { dispatch, rejectWithValue }) => {
    const response = await services.getRequestsEnrollmentsFilterOptions()
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getRequestsEnrollments = createAsyncThunk(
  `${REQUESTS_ENROLLMENTS_SLICE_NAME}/get_requests_enrollments`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getEnrollmentsRequests(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const updateRequestsEnrollment = createAsyncThunk(
  `${REQUESTS_ENROLLMENTS_SLICE_NAME}/update_requests_enrollment`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.updateEnrollmentRequests(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    dispatch(getStatisticsAdmin())
    return response.data
  }
)

export const deleteRequestsEnrollment = createAsyncThunk(
  `${REQUESTS_ENROLLMENTS_SLICE_NAME}/delete_requests_enrollment`,
  async (id, { dispatch, rejectWithValue }) => {
    const response = await services.deleteEnrollmentRequests(id)
    if (!(response.ok && (response.data || response.status === 204))) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    dispatch(getStatisticsAdmin())
    return { id, message: response.data?.message?.detail || response.data?.message }
  }
)

// Legacy `bulkUpdateRequestsEnrollmentActions.extraAction` pointed at
// `BusinessAccountsActions.getStatisticsAdminRequest` - a reduxsauce creator that was never
// imported into that saga file, so referencing it would throw as soon as the module loaded.
// It was clearly meant to refresh admin statistics after a bulk update, same as the sibling
// update/delete actions in this module (`extraAction: [getStatisticsAdmin]`), so that's what
// this thunk does.
export const bulkUpdateRequestsEnrollment = createAsyncThunk(
  `${REQUESTS_ENROLLMENTS_SLICE_NAME}/bulk_update_requests_enrollment`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.bulkUpdateEnrollmentRequestStatus(params)
    if (!response.ok) {
      // withoutErrorNotification on the legacy action - no handleApiError call
      return rejectWithValue(response.data)
    }
    dispatch(getStatisticsAdmin())
    return response.data
  }
)

export const getRequestsEnrollmentsExport = createAsyncThunk(
  `${REQUESTS_ENROLLMENTS_SLICE_NAME}/get_requests_enrollments_export`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getRequestsEnrollmentsExport(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
